import React from 'react';

import styles from './styles.module.less';

const Problem = () => {

    return (
        <div className={styles.problem_box}>
            <div className={styles.box}>
                <h1>常见问题</h1>
                <div className={styles.content}>
                    <dl>
                        <dt>Q1：弹出安装海外环网软件客户端时，“Windows已保护你的电脑”弹窗，该如何解决?</dt>
                        <dd>
                            <img src="/image/problem1-1.png" alt="" />
                        </dd>
                        <dd>
                            A1：首先点击“更多信息”，然后选择“仍要运行”即可解决安装遇到的此问题。
                        </dd>
                        <dd>
                            <img src="/image/problem1-2.png" alt="" />
                        </dd>
                    </dl>
                    <dl>
                        <dt>Q2：拨号连接至海外环网如果显示“CGBXSeclnput进行了兼容性设置，刷新浏览器即可使用”的内容该如何处理？</dt>
                        <dd>
                            <img src="/image/problem2-1.png" alt="" />
                        </dd>
                        <dd>
                            A2：点击提示内容里面的右上角“x”，关闭提示页面。
                        </dd>
                    </dl>
                    <dl>
                        <dt>Q3：如果登录不上海外环网软件客户端，想要修改密码怎么办？</dt>
                        <dd>
                            A3：各成员单位同事可以联系成员单位4A管理员，进行账号密码重置。
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    )
};

export default Problem;